import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space, Modal, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faCloudDownload, faEye, faRecycle, faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  revokePullOurRequest
} from "../../../controllers/V1/pullOutRequestController";
import { getPage } from "../../../controllers/common";

import ExportPopup from './Export';
import { usePermissions } from "../../../controllers/PermissionContext";
import moment from "moment";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";

const isStageCompleted = (value) =>
  String(value ?? "").toLowerCase() === "completed";

function PullOutStatusDots({ item }) {
  const overall = item?.status;
  if (String(overall ?? "").toLowerCase() === "rejected") {
    return <span>{item?.status}</span>;
  }
  const dots =
    String(overall ?? "").toLowerCase() === "completed"
      ? ["green", "green", "green"]
      : [
          isStageCompleted(item?.deployment_status) ? "green" : "red",
          isStageCompleted(item?.account_status) ? "green" : "red",
          isStageCompleted(item?.bdm_status) ? "green" : "red",
        ];
  return (
    <span
      className="pull-out-status-dots"
      style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
      title={`Account: ${item?.account_status ?? "-"} · Deployment: ${item?.deployment_status ?? "-"} · BDM: ${item?.bdm_status ?? "-"}`}
    >
      {dots.map((c, i) => (
        <span
          key={i}
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: c === "green" ? "#28a745" : "#dc3545",
            flexShrink: 0,
          }}
        />
      ))}
    </span>
  );
}

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("userPullOutRequest");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'pos_number'?{pos_number : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'store_name'?{store_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'mobile'?{mobile : parseInt(filter?.search) }:null),
          ...(filter?.bind_person_id ? {bind_person_id: {$in : filter?.bind_person_id}} : null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {  },
        sort: { createdAt: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFilterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Pull Out Request List";
  }, [currentPage, showRequest, isFilterShow, LIMIT]);

  const handleView = async (item) => {
    try {
      navigate("/request/pull-out-view",{state : item});
    } catch (error) {
      
    }
  }
  const handleBindWith = (value) => {
    setFilter((pre) => ({ ...pre, bind_person_id: value }));
  }

  /*********************************************************
   *  This function is for handle limit change
   *********************************************************/
  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setCurrentPage(1);
    setSkip(0);
  };

  const theadThStyle = {
    backgroundColor: "#b71c1c",
    color: "#fff",
    borderColor: "#8e0000",
  };

  const handleRevoke = async (item) => {
    try {
      const res = await revokePullOurRequest({ id: item?._id });
      if (res.status === true) {
        notification.open({
          message: "Success.",
          description: "Request revoked successfully.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
          duration: 2,
        });
        getList();
      } else {
        notification.open({
          message: "Oops!.",
          description: res?.message || "Failed to revoke request.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Oops!.",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    }
  };

  const confirmRevoke = (item) => {
    Modal.confirm({
      title: "Revoke Pull Out Request",
      content: "Are you sure you want to revoke this pull out request?",
      okText: "Yes, Revoke",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => handleRevoke(item),
    });
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Pull Out Request List"} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() =>  setShowRequest("") }
                    />
                    <Tab
                      label="Pending"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Pending")}
                    />

                    <Tab
                      label="Completed"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Completed")}
                    />

                    <Tab
                      label="Rejected"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Rejected")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFilterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {/* {(PERMISSION?.export === 'Y' || PERMISSION?.fullAccess === 'Y') && ( */}
                    <div className="inventory_filter_div" onClick={handleExportDrawer}>
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                    <div className="inventory_filter_div" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label htmlFor="rowsPerPage" style={{ margin: 0, fontSize: "14px", whiteSpace: "nowrap" }}>
                      Rows:
                    </label>
                    <select
                      id="rowsPerPage"
                      value={LIMIT}
                      onChange={handleLimitChange}
                      className="form-control"
                      style={{
                        minWidth: "80px",
                        padding: "4px 8px",
                        fontSize: "14px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        cursor: "pointer"
                      }}
                    >
                      <option value={2}>2</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  {/* )} */}
                  
                  {/* <div onClick={() => toggleAddEditPopup()}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div> */}
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div
                    className="card shadow mb-4"
                    style={{
                      backgroundColor: "#ef9a9a",
                      borderLeft: "4px solid #b71c1c",
                    }}
                  >
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                        >
                          <thead>
                            <tr>
                              <th style={theadThStyle}>Sl. No.</th>
                              <th style={theadThStyle}>Customer's Details</th>
                              <th style={theadThStyle}>Bind With</th>
                              <th style={theadThStyle}>Contact No.</th>
                              <th style={theadThStyle}>Collection Received</th>
                              <th style={theadThStyle}>POS Condition</th>
                              <th style={theadThStyle}>Status</th>
                              <th style={theadThStyle}>Created At</th>
                              <th style={theadThStyle}>Updated At</th>
                              {(PERMISSION?.view === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                <th style={theadThStyle}>Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      {items?.users_id?.store_name        && (<span>Store   : {items?.users_id?.store_name}<br/></span>)} 
                                      {items?.users_id?.users_name        && (<span>Name    : {items?.users_id?.users_name} {items?.users_id?.last_name}<br/></span>)} 
                                      {items?.users_id?.users_mobile      && (<span>Email   : {items?.users_id?.users_mobile}<br/></span>)} 
                                      {items?.users_id?.pos_number        && (<span>POS number  : {items?.users_id?.pos_number}<br/></span>)}                                       
                                    </td>
                                    <td className="admin_user_list_date">
                                      {items?.bind_person_id?.users_name && (<span>{items?.bind_person_id?.users_name}<br/></span>)}
                                      {items?.bind_person_id?.users_type && (<span>Type : {items?.bind_person_id?.users_type}<br/></span>)}
                                      {items?.bind_person_id?.users_mobile && (<span>Phone : {items?.bind_person_id?.users_mobile}<br/></span>)}
                                    </td>
                                    <td className="admin_user_list_date">{ items?.contact_no}</td>
                                    <td className="admin_user_list_date">{ items?.collection_received === "Y" ? "Yes" : "No"}</td>
                                    <td className="admin_user_list_date">{ items?.pos_condition}</td>
                                    <td className="admin_user_list_date">
                                      <PullOutStatusDots item={items} />
                                    </td>
                                    <td className="admin_user_list_date">{moment(items?.createdAt).format('DD-MM-YYYY HH:mm')}</td>
                                    <td className="admin_user_list_date">{moment(items?.updatedAt).format('DD-MM-YYYY HH:mm')}</td>
                                    {(PERMISSION?.view === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                      <td>
                                        <button type="button" class="btn btn-dark" onClick={()=>handleView(items)}>
                                          <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        <button type="button" class="btn btn-dark mt-2" onClick={() => confirmRevoke(items)}>
                                          <FontAwesomeIcon icon={faRecycle} />
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="select_bind_with" className="all_section_for_label_main_class" >
                  Select Bind With :
                </label>
                <UserSelectWithSearch
                  value={filter?.bind_person_id}
                  onChange={(value) => handleBindWith(value)}
                  placeholder="Select bind with users"
                  className="form-control store_input_field"
                  style={{ width: '100%' }}
                  disableOptions={false}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='pos_number' selected={filter?.filter_by ==='pos_number'?true:false}>POS Number</option>
                  <option value='store_name' selected={filter?.filter_by ==='store_name'?true:false}>Store name</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
